/*
 * Zepto Product Personalizer — reflect "file selected" on the dropzone.
 * ------------------------------------------------------------
 * The dropzone styling lives in zepto-personalizer.css, but Zepto does
 * NOT reveal its own <img> preview on this store after a file is picked,
 * so the dropzone had no visible "chosen" state (and the styled overlay
 * hides the native filename). This toggles `.pplr-has-file` and stores
 * the file name in `data-pplr-filename` on the `.pplrfileuploadbutton`
 * whenever its file <input> changes, which the CSS turns into a
 * checkmark + "Image selected" + the file name.
 *
 * Uses event delegation so it works regardless of when Zepto injects
 * its (async) markup, and re-scans on load / bfcache restore.
 * ------------------------------------------------------------
 */
(function () {
  function reflect(input) {
    var zone = input.closest && input.closest('.pplrfileuploadbutton');
    if (!zone) return;
    var hasFile = input.files && input.files.length > 0;
    zone.classList.toggle('pplr-has-file', hasFile);
    if (hasFile) {
      zone.setAttribute('data-pplr-filename', input.files[0].name);
    } else {
      zone.removeAttribute('data-pplr-filename');
    }
  }

  function isUploadInput(el) {
    return el && el.matches && el.matches('.pplrfileuploadbutton input[type="file"]');
  }

  // Catch every file pick, even on Zepto's async-injected inputs.
  document.addEventListener(
    'change',
    function (e) {
      if (isUploadInput(e.target)) reflect(e.target);
    },
    true
  );

  // Sync any inputs that already hold a file (e.g. back/forward cache).
  function scan() {
    document
      .querySelectorAll('.pplrfileuploadbutton input[type="file"]')
      .forEach(reflect);
  }

  if (document.readyState !== 'loading') {
    scan();
  } else {
    document.addEventListener('DOMContentLoaded', scan);
  }
  window.addEventListener('pageshow', scan);
})();

/*
 * Cart line-item image preview (lightbox).
 * ------------------------------------------------------------
 * snippets/cart-item.liquid renders `[data-zepto-preview-url]` triggers
 * for uploaded images. The cart re-renders through the Section Rendering
 * API (innerHTML), which does NOT execute inline <script>, so the handler
 * must be global + delegated (it was previously an inline script in the
 * snippet, which never ran for AJAX-injected cart items). Overlay styles
 * live in zepto-personalizer.css.
 * ------------------------------------------------------------
 */
(function () {
  var overlay = null;
  var imgEl = null;

  function ensureOverlay() {
    if (overlay && document.body.contains(overlay)) return;
    overlay = document.getElementById('zepto-preview-overlay');
    if (overlay) {
      imgEl = overlay.querySelector('.zepto-preview-overlay__img');
      return;
    }
    // Build with DOM methods (no innerHTML) — content is static anyway.
    overlay = document.createElement('div');
    overlay.id = 'zepto-preview-overlay';
    overlay.className = 'zepto-preview-overlay';

    var inner = document.createElement('div');
    inner.className = 'zepto-preview-overlay__inner';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'zepto-preview-overlay__close';
    closeBtn.setAttribute('aria-label', 'Close preview');
    closeBtn.textContent = '×'; // ×
    closeBtn.addEventListener('click', closePreview);

    imgEl = document.createElement('img');
    imgEl.className = 'zepto-preview-overlay__img';
    imgEl.alt = 'Preview image';

    inner.appendChild(closeBtn);
    inner.appendChild(imgEl);
    overlay.appendChild(inner);
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePreview();
    });
  }

  function openPreview(url) {
    if (!url) return;
    ensureOverlay();
    imgEl.src = url;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePreview() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (imgEl) imgEl.src = '';
    }, 300);
  }

  // Delegated so it also covers cart items injected later via AJAX re-render.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-zepto-preview-url]');
    if (!trigger) return;
    e.preventDefault();
    openPreview(trigger.getAttribute('data-zepto-preview-url'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) {
      closePreview();
    }
  });
})();
